function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*! jQuery Validation Plugin - v1.19.3 - 1/9/2021
 * https://jqueryvalidation.org/
 * Copyright (c) 2021 Jörn Zaefferer; Licensed MIT */
!function (a) {
  "function" == typeof define && define.amd ? define(["jquery", "../jquery.validate.min"], a) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = a(require("jquery")) : a(jQuery);
}(function (a) {
  return a.extend(a.validator.messages, {
    required: "Dit is een verplicht veld.",
    remote: "Controleer dit veld.",
    email: "Vul hier een geldig e-mailadres in.",
    url: "Vul hier een geldige URL in.",
    date: "Vul hier een geldige datum in.",
    dateISO: "Vul hier een geldige datum in (ISO-formaat).",
    number: "Vul hier een geldig getal in.",
    digits: "Vul hier alleen getallen in.",
    creditcard: "Vul hier een geldig creditcardnummer in.",
    equalTo: "Vul hier dezelfde waarde in.",
    extension: "Vul hier een waarde in met een geldige extensie.",
    maxlength: a.validator.format("Vul hier maximaal {0} tekens in."),
    minlength: a.validator.format("Vul hier minimaal {0} tekens in."),
    rangelength: a.validator.format("Vul hier een waarde in van minimaal {0} en maximaal {1} tekens."),
    range: a.validator.format("Vul hier een waarde in van minimaal {0} en maximaal {1}."),
    max: a.validator.format("Vul hier een waarde in kleiner dan of gelijk aan {0}."),
    min: a.validator.format("Vul hier een waarde in groter dan of gelijk aan {0}."),
    step: a.validator.format("Vul hier een veelvoud van {0} in."),
    iban: "Vul hier een geldig IBAN in.",
    dateNL: "Vul hier een geldige datum in.",
    phoneNL: "Vul hier een geldig Nederlands telefoonnummer in.",
    mobileNL: "Vul hier een geldig Nederlands mobiel telefoonnummer in.",
    postalcodeNL: "Vul hier een geldige postcode in.",
    bankaccountNL: "Vul hier een geldig bankrekeningnummer in.",
    giroaccountNL: "Vul hier een geldig gironummer in.",
    bankorgiroaccountNL: "Vul hier een geldig bank- of gironummer in."
  }), a;
});